export type Offer = {
  price: number
  price_lastchance: number
  old_price: number
  new_price: number
  currency: string
  currency_name: string
  payment_methods: string[]
  id: number
  inline_checkout: boolean
}

export type OfferParams = {
  chance_price: number
  id: number
  price: number
  payment_methods: string[]
  display_data: { [key: string]: any }
}

export enum OfferPriceType {
  standard = 'standard',
  chance = 'chance',
  unsubscribe = 'unsubscribe',
}

export type OfferPrice = {
  id: number
  type: OfferPriceType
  payment_type: number
  amount: number
  amount_in_euro: number
  display_price: string
  display_data: { [key: string]: string }
  extra_data: {
    stripe_price_id: string
  }
}

export type OfferApi = {
  id: number
  amount: number
  chance_amount: number
  price_in_euro: number
  chance_price_in_euro: number
  locale: string
  country: string
  paymodes: string[]
  currency: {
    id: number
    name: string
    symbol: string
  }
  offer_prices: OfferPrice[]
  inline_checkout: boolean
}
